import axios from "axios";
import { awsUploadURL } from "utils/constants";

const awsFileUpload = async (inputs) => {
    try {
        // delete keys with non-file values
        Object.keys(inputs).forEach((key) => {
            if (!inputs[key] || inputs[key].constructor !== File) {
                delete inputs[key];
            }
        });

        const awsFiles = await Promise.all(
            Object.entries(inputs).map(async (input) => {
                const [fieldName, file] = input;
                if (file) {
                    const formData = new FormData();
                    formData.append("image", file);
                    const response = await axios.post(awsUploadURL, formData);
                    return { [fieldName]: response?.data?.url ? response.data.url : "" };
                }
                return null;
            }),
        );

        return awsFiles.reduce((obj, prop) => ({ ...obj, ...(prop !== null && prop) }), {});
    } catch (error) {
        return null;
    }
};

export default awsFileUpload;
